var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9993 16.0003C11.7656 16.0007 11.5392 15.9194 11.3593 15.7703L5.3593 10.7703C5.15508 10.6005 5.02666 10.3566 5.00228 10.0922C4.9779 9.82777 5.05956 9.56449 5.2293 9.36028C5.39904 9.15606 5.64295 9.02763 5.90738 9.00325C6.1718 8.97888 6.43508 9.06054 6.6393 9.23028L11.9993 13.7103L17.3593 9.39028C17.4616 9.30721 17.5793 9.24518 17.7056 9.20775C17.832 9.17031 17.9645 9.15822 18.0955 9.17216C18.2265 9.1861 18.3535 9.2258 18.4691 9.28897C18.5848 9.35214 18.6868 9.43755 18.7693 9.54028C18.8609 9.6431 18.9302 9.76372 18.973 9.8946C19.0158 10.0255 19.0311 10.1638 19.018 10.3008C19.0048 10.4379 18.9635 10.5708 18.8967 10.6911C18.8298 10.8115 18.7387 10.9167 18.6293 11.0003L12.6293 15.8303C12.4442 15.9558 12.2224 16.0156 11.9993 16.0003Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowIcon);
export default __webpack_public_path__ + "static/media/downArrowIcon.457897b5dc194270ea704a0f141f21b6.svg";
export { ForwardRef as ReactComponent };